<template>
  <div>
    <div class="container-fluid mt-4">
      <h2 class="h2">{{ dataConfig.title }}</h2>
      <b-row>
        <b-col lg="12">
          <datatable :DataConfig="dataConfig" v-bind="$data" />
        </b-col>
        <b-col lg="4" style="display: flex;">
          <b-card :title="dataConfig.title + ' über Datei hinzufügen'">
            <input style="padding-bottom: 10px;" type="file" ref="file" id="input"/>
            <b-btn v-on:click="loadTextFromFile">Vorschau laden</b-btn>
          </b-card>
          <b-alert style="margin-top: 5px; margin-bottom: 5px;" :show="loading" variant="info">Lädt Daten...</b-alert>
        </b-col>
        <b-col v-if="showPreview" lg="12">
          <b-card :title="'Vorschau (max. 10 Zeilen)'">
            <b-btn v-on:click="submitFile(experimentName, true)">Daten hochladen</b-btn>
            <b-btn v-on:click="deleteDataPreview()">Daten verwerfen</b-btn>
            <div v-if="warnings.length" style="margin: 5px;">
              <p class="text-warning" v-for="(warn, ind) in warnings" :key="ind" v-html="warn" />
                <information
                  :info-text="`Mögliche Kategorien sind: ${headerLabels.join(', ')}`"
                />
            </div>
            <ul class="nav nav-tabs">
              <li v-for="(dataSet, name) in previewDataSets" :key="name">
                <a @click="dataSetName=name"> <b-nav-item> {{ name }} </b-nav-item> </a>
              </li>
            </ul>
            <datatable
              :data="previewData.slice(0, 10)"
              :columns="previewColumns"
              :query="{ limit: 20, offset: 0, sort: 'exudate', order: 'ASC', freeTextFilters: {}, assocFilters: {} }"
              :total="previewData.length"
              :HeaderSettings="false"
              :Pagination="false"
              :Export="false"
            />
          </b-card>
        </b-col>
        <b-col lg="12">
          <akribes-form
            :dataConfig="dataConfig"
            :containsImages="false"
            :routeID="routeID"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import config from '../config.json'
import api from '@/api'
import mixins from '../mixins/table_mixins'
import helpers from '@/mixins/helper-functions'
import AkribesForm from './plugins/AkribesForm'
import readXlsxFile from 'read-excel-file'

export default {
  name: 'Proliferation-Assay',
  components: {
    'akribes-form': AkribesForm,
    FilterTh: () => import('./plugins/th-Filter')
  },
  mixins: [mixins],
  data () {
    return {
      columns: [],
      data: [],
      model: {},
      total: 0,
      germanToEnglish: helpers.germanToEnglish(this.dataConfig),
      query: { limit: 20, offset: 0, sort: 'exudate', order: 'ASC', freeTextFilters: {}, assocFilters: {} }
    }
  },
  computed: {
    routeID () {
      return this.$route.params.id
    },
    experimentName () {
      return this.$route.params.experiment
    },
    dataConfig () {
      return config.exudats[this.experimentName]
    },
    file () {
      return this.$refs.file
    }
  },
  methods: {
    async refreshPosts () {
      this.loading = true
      const config = this.dataConfig
      const sortVal = this.query.sort
      let serverQuery = {...this.query}
      if (sortVal.includes('concentration_')) { // Sort not only by chosen concentration, but also by all the lower ones
        const allConcentrations = config.tableHeader.map(head => head.db_key).filter(head => head.includes('concentration_'))
        const relevantConcentrations = allConcentrations.slice(allConcentrations.indexOf(sortVal))
        serverQuery.sort = relevantConcentrations
      }
      serverQuery.order += ' NULLS LAST'
      try {
        var response = await api.getPosts(`exudats/${this.experimentName}`, serverQuery)
      } catch (err) {
        this.loading = false
        return
      }
      var dbData = response.result
      var columns = response.columns
      this.columns = config.tableHeader.map(function (header) {
        return {
          title: header.label,
          field: header.db_key,
          visible: helpers.columnIsVisible(columns, header.db_key, header.visible),
          isChecked: helpers.columnIsVisible(columns, header.db_key, header.visible),
          sortable: true,
          category: header.category,
          thComp: 'FilterTh',
          filterType: (header.input_type === 'Number') ? 'Number' : 'FreeText'
        }
      })
      this.data = dbData.rows
      this.total = dbData.count
      this.loading = false
    },
    loadTextFromFile () {
      const input = this.file
      const germanToEnglish = this.germanToEnglish
      this.sheetOptions.forEach(op => {
        var currOptions = { sheet: op }
        readXlsxFile(input.files[0], currOptions).then((rows) => {
          var headers
          if (this.experimentName === 'we') {
            headers = rows[1]
          } else {
            headers = rows[0] // Table Headers
            var headerIndex = headers.findIndex(el => !el) - 1
            var superHeader = headers[headerIndex] // Super header, such as 'WE concentration (%)'
            var subHeaders = rows[1].filter(row => typeof row === 'number') // Sub-Headers, such as 8, 4, 2, 1, 0.5
            var unit = rows[1].find(el => typeof el === 'string')

            subHeaders.forEach((head, ind) => {
              headers[ind + headerIndex] = superHeader + ': ' + head
            })
          }

          rows = rows.slice(2)
          var inputData = rows.map(function (row) {
            var rowObj = {}
            headers.forEach((head, idx) => {
              if (row[idx] !== null) {
                rowObj[germanToEnglish[head]] = '' + row[idx]
              }
              if (unit) {
                rowObj.unit = unit
              }
            })
            delete rowObj.undefined
            return rowObj
          })
          this.xlsxInput[op] = inputData
          this.createDataPreview(this.xlsxInput)
        }).catch((err) => {
          console.log(err)
          alert(`Sheet ${op} wurde nicht gefunden. Überprüfen Sie ggfs. die Sheet-Namen in der Datei.`)
        })
      })
    }
  },
  watch: {
    experimentName () {
      this.query.sort = 'exudate'
      this.refreshPosts()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Proliferation.vue